<div id="validation">
  <div
    id="validation-form-wrapper"
    fxLayout="column"
    fxLayoutAlign="center center">
    <div id="validation-form">
      <div class="horizontal-stepper-wrapper">
        <!-- HORIZONTAL STEPPER EXAMPLE -->
        <div class="horizontal-stepper-wrapper">
          <mat-horizontal-stepper
            class="mat-elevation-z1 mat-stepper-horizontal"
            [linear]="true"
            labelPosition="bottom">
            <mat-step [stepControl]="horizontalStepperStep1">
              <ng-template matStepLabel>{{
                'VALIDATION.STEPONE.TITLE' | translate
              }}</ng-template>
              <form fxLayout="column" [formGroup]="horizontalStepperStep1">
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline">
                    <mat-label>{{
                      'USERS.SINGLE.INFO.OFFICIALFIRSTNAME' | translate
                    }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="officialFirstName" />
                  </mat-form-field>
                </div>
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline">
                    <mat-label>{{
                      'USERS.SINGLE.INFO.OFFICIALLASTNAME' | translate
                    }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="officialLastName" />
                  </mat-form-field>
                </div>
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline">
                    <mat-label>{{
                      'USERS.SINGLE.INFO.DATEOFBIRTH' | translate
                    }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="dateOfBirth" />
                  </mat-form-field>
                </div>
                <div fxFlex="2 0 auto" fxLayout="row">
                  <mat-form-field fxFlex="100" appearance="outline">
                    <mat-label>{{
                      'USERS.SINGLE.INFO.GENDER' | translate
                    }}</mat-label>
                    <input
                      autoComplete="on"
                      matInput
                      formControlName="gender" />
                  </mat-form-field>
                </div>
                <div
                  class="general-container"
                  fxLayout="row"
                  fxLayoutAlign="center center">
                  <button
                    mat-raised-button
                    matStepperNext
                    type="button"
                    color="accent">
                    {{ 'GENERAL.NEXT' | translate }}
                  </button>
                </div>
              </form>
            </mat-step>
            <mat-step [stepControl]="horizontalStepperStep2">
              <ng-template matStepLabel>{{
                'VALIDATION.STEPTWO.TITLE' | translate
              }}</ng-template>
              <form fxLayout="column" [formGroup]="horizontalStepperStep2">
                <div fxFlex="1 0 auto" fxLayout="column">
                  @if (hasMultipleFirstName) {
                    <div fxFlex="2 0 auto" fxLayout="row">
                      <mat-form-field fxFlex="90" appearance="outline">
                        <mat-label>{{
                          'USERS.SINGLE.INFO.USUALFIRSTNAME' | translate
                        }}</mat-label>
                        <input
                          autoComplete="on"
                          matInput
                          formControlName="firstName"
                          required />
                        <mat-error>{{
                          'ERROR.FIRSTNAME' | translate
                        }}</mat-error>
                      </mat-form-field>
                      <div
                        fxFlex="10"
                        fxLayoutAlign="center center"
                        class="container-form-tooltip">
                        <mat-icon
                          class="mat-icon-custom"
                          matTooltip="{{
                            'GENERAL.TOOLTIP.FIRSTNAME' | translate
                          }}"
                          >help</mat-icon
                        >
                      </div>
                    </div>
                  }
                  @if (!hasMultipleFirstName) {
                    <div fxFlex="2 0 auto" fxLayout="row">
                      <mat-form-field fxFlex="90" appearance="outline">
                        <mat-label>{{
                          'USERS.SINGLE.INFO.USUALFIRSTNAME' | translate
                        }}</mat-label>
                        <input
                          autoComplete="on"
                          matInput
                          formControlName="firstName"
                          required />
                        <mat-error>{{
                          'ERROR.FIRSTNAME' | translate
                        }}</mat-error>
                      </mat-form-field>
                    </div>
                  }
                  @if (hasMultipleLastName) {
                    <div fxFlex="2 0 auto" fxLayout="row">
                      <mat-form-field fxFlex="90" appearance="outline">
                        <mat-label>{{
                          'USERS.SINGLE.INFO.USUALLASTNAME' | translate
                        }}</mat-label>
                        <input
                          autoComplete="on"
                          matInput
                          formControlName="lastName"
                          required />
                        <mat-error>{{
                          'ERROR.LASTNAME' | translate
                        }}</mat-error>
                      </mat-form-field>
                      <div
                        fxFlex="10"
                        fxLayoutAlign="center center"
                        class="container-form-tooltip">
                        <mat-icon
                          matTooltip="{{
                            'GENERAL.TOOLTIP.LASTNAME' | translate
                          }}"
                          class="mat-icon-custom"
                          >help</mat-icon
                        >
                      </div>
                    </div>
                  }
                  @if (!hasMultipleLastName) {
                    <div fxFlex="2 0 auto" fxLayout="row">
                      <mat-form-field fxFlex="90" appearance="outline">
                        <mat-label>{{
                          'USERS.SINGLE.INFO.USUALLASTNAME' | translate
                        }}</mat-label>
                        <input
                          autoComplete="on"
                          matInput
                          formControlName="lastName"
                          required />
                        <mat-error>{{
                          'ERROR.LASTNAME' | translate
                        }}</mat-error>
                      </mat-form-field>
                    </div>
                  }
                  <div fxFlex="2 0 auto" fxLayout="row">
                    <mat-form-field fxFlex="90" appearance="outline">
                      <mat-label>{{
                        'USERS.SINGLE.INFO.PREFERREDLANGUAGE' | translate
                      }}</mat-label>
                      <mat-select formControlName="preferredLanguage">
                        @for (lang of preferredLanguage; track lang) {
                          <mat-option [value]="lang">
                            {{ lang.name }}
                          </mat-option>
                        }
                      </mat-select>
                      <mat-error>{{
                        'ERROR.PREFERREDLANGUAGE' | translate
                      }}</mat-error>
                    </mat-form-field>
                    <div
                      fxFlex="10"
                      fxLayoutAlign="center center"
                      class="container-form-tooltip">
                      <mat-icon
                        matTooltipClass="tooltip"
                        matTooltip="{{
                          'VALIDATION.STEPTWO.PREFERREDLANGUAGE.TOOLTIP'
                            | translate
                        }}"
                        class="mat-icon-custom"
                        >help</mat-icon
                      >
                    </div>
                  </div>
                </div>
                <div
                  class="general-container"
                  fxLayout="row"
                  fxLayoutAlign="center center">
                  <button
                    class="btn-previous"
                    mat-raised-button
                    matStepperPrevious
                    type="button"
                    color="accent">
                    {{ 'GENERAL.PREVIOUS' | translate }}
                  </button>
                  <button
                    mat-raised-button
                    matStepperNext
                    type="button"
                    color="accent">
                    {{ 'GENERAL.NEXT' | translate }}
                  </button>
                </div>
              </form>
            </mat-step>
            <mat-step [stepControl]="horizontalStepperStep3">
              <ng-template matStepLabel>{{
                'VALIDATION.STEP3.TITLE' | translate
              }}</ng-template>
              <form fxLayout="column" [formGroup]="horizontalStepperStep3">
                <div fxFlex="1 0 auto" fxLayout="column">
                  <h3>{{ 'VALIDATION.STEP3.F2A.MOREINFO' | translate }}</h3>
                  <mat-tab-group [selectedIndex]="selectedTab">
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <mat-icon class="example-tab-icon">smartphone</mat-icon>
                        {{ 'VALIDATION.STEP3.F2A.APPS' | translate }}
                      </ng-template>
                      <div cdk-scrollable class="tab-container">
                        <div class="text-container" fxlayout="row">
                          <div class="choice-container" fxFlex="30%">
                            <img
                              src="assets/images/f2a/f2a-app.png"
                              alt="Image F2A par application" />
                          </div>
                          <div class="choice-container" fxFlex="70%">
                            {{ 'VALIDATION.STEP3.F2A.APPSINTRO' | translate }}
                          </div>
                        </div>
                        <div class="text-container">
                          <div class="condition-container">
                            <p>
                              {{
                                'VALIDATION.STEP3.F2A.APPSCONDITION1'
                                  | translate
                              }}
                            </p>
                            <p>
                              {{
                                'VALIDATION.STEP3.F2A.APPSCONDITION2'
                                  | translate
                              }}
                            </p>
                            <p>
                              {{
                                'VALIDATION.STEP3.F2A.APPSCONDITION3'
                                  | translate
                              }}
                            </p>
                            <p>
                              {{
                                'VALIDATION.STEP3.F2A.APPSCONDITION4'
                                  | translate
                              }}
                              <strong>{{
                                'VALIDATION.STEP3.F2A.APPSCONDITION5'
                                  | translate
                              }}</strong>
                            </p>
                            <p>
                              {{
                                'VALIDATION.STEP3.F2A.APPSCONDITION6'
                                  | translate
                              }}
                            </p>
                            <p>
                              {{
                                'VALIDATION.STEP3.F2A.APPSCONDITION7'
                                  | translate
                              }}
                              <strong>{{
                                'VALIDATION.STEP3.F2A.APPSCONDITION8'
                                  | translate
                              }}</strong>
                            </p>
                          </div>
                        </div>
                      </div>
                    </mat-tab>
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <mat-icon class="example-tab-icon"
                          >perm_phone_msg</mat-icon
                        >
                        {{ 'VALIDATION.STEP3.F2A.SMS' | translate }}
                      </ng-template>
                      <div cdk-scrollable class="tab-container">
                        <div class="text-container" fxlayout="row">
                          <div class="choice-container" fxFlex="30%">
                            <img
                              src="assets/images/f2a/f2a-sms.png"
                              alt="Image F2A par sms" />
                          </div>
                          <div class="choice-container" fxFlex="70%">
                            {{ 'VALIDATION.STEP3.F2A.SMSINTRO' | translate }}
                          </div>
                        </div>
                        <div class="text-container">
                          <div class="condition-container">
                            <p>
                              {{
                                'VALIDATION.STEP3.F2A.APPSCONDITION1'
                                  | translate
                              }}
                            </p>
                            <p>
                              {{
                                'VALIDATION.STEP3.F2A.APPSCONDITION2'
                                  | translate
                              }}
                            </p>
                            <p>
                              {{
                                'VALIDATION.STEP3.F2A.APPSCONDITION3'
                                  | translate
                              }}
                            </p>
                            <p>
                              {{
                                'VALIDATION.STEP3.F2A.APPSCONDITION4'
                                  | translate
                              }}
                              <strong>{{
                                'VALIDATION.STEP3.F2A.APPSCONDITION5'
                                  | translate
                              }}</strong>
                            </p>
                            <p>
                              {{
                                'VALIDATION.STEP3.F2A.APPSCONDITION6'
                                  | translate
                              }}
                            </p>
                            <p>
                              {{
                                'VALIDATION.STEP3.F2A.APPSCONDITION7'
                                  | translate
                              }}
                              <strong>{{
                                'VALIDATION.STEP3.F2A.APPSCONDITION8'
                                  | translate
                              }}</strong>
                            </p>
                          </div>
                        </div>
                      </div>
                    </mat-tab>
                    <mat-tab>
                      <ng-template mat-tab-label>
                        <mat-icon class="example-tab-icon"
                          >chrome_reader_mode</mat-icon
                        >
                        {{ 'VALIDATION.STEP3.F2A.TOKEN' | translate }}
                      </ng-template>
                      <div cdk-scrollable class="tab-container">
                        <div class="text-container" fxlayout="row">
                          <div class="choice-container" fxFlex="30%">
                            <img
                              src="assets/images/f2a/f2a-token.png"
                              alt="Image F2A par token" />
                          </div>
                          <div class="choice-container" fxFlex="70%">
                            {{ 'VALIDATION.STEP3.F2A.TOKENINTRO' | translate }}
                          </div>
                        </div>
                      </div>
                    </mat-tab>
                  </mat-tab-group>
                  <mat-divider></mat-divider>
                  <h3>{{ 'VALIDATION.STEP3.F2A.TITLE' | translate }}</h3>
                  <div>
                    <mat-radio-group
                      class="example-radio-group"
                      formControlName="f2a"
                      required
                      (change)="changeF2A($event)">
                      <mat-radio-button
                        class="example-radio-button"
                        checked="true"
                        [value]="'App'">
                        {{ 'VALIDATION.STEP3.F2A.APPS' | translate }}
                      </mat-radio-button>
                      <mat-radio-button
                        class="example-radio-button"
                        [value]="'SMS'">
                        {{ 'VALIDATION.STEP3.F2A.SMS' | translate }}
                      </mat-radio-button>
                      <mat-radio-button
                        class="example-radio-button"
                        [value]="'Token'">
                        {{ 'VALIDATION.STEP3.F2A.TOKEN' | translate }}
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                  @if (displayPhone) {
                    <div
                      fxFlex="2 0 auto"
                      fxLayout="row"
                      class="general-container">
                      <mat-form-field fxFlex="32" appearance="outline">
                        <mat-select
                          placeholder="Country"
                          formControlName="defaultDial"
                          required>
                          <mat-option [value]="'+41'"> +41 </mat-option>
                          <mat-option [value]="'+33'"> +33 </mat-option>
                          <mat-option [value]="'+49'"> +49 </mat-option>
                          <mat-option [value]="'+39'"> +39 </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field fxFlex="58" appearance="outline">
                        <mat-label>{{
                          'USERS.SINGLE.INFO.PHONE' | translate
                        }}</mat-label>
                        <input
                          autoComplete="on"
                          matInput
                          formControlName="phone"
                          required
                          [maxLength]="maxlength"
                          placeholder="791234567" />
                        <mat-error>{{ 'ERROR.PHONE' | translate }}</mat-error>
                      </mat-form-field>
                      <div
                        fxFlex="10"
                        fxLayoutAlign="center center"
                        class="container-form-tooltip">
                        <mat-icon
                          matTooltip="{{
                            'VALIDATION.STEPTWO.PHONE.TOOLTIP' | translate
                          }}"
                          class="mat-icon-custom"
                          >help</mat-icon
                        >
                      </div>
                    </div>
                  }
                  <mat-divider></mat-divider>
                  <mat-checkbox
                    formControlName="f2aCondition"
                    class="general-container"
                    required
                    #tc>
                    {{
                      'VALIDATION.STEP3.F2A.CHECKBOX' | translate
                    }}</mat-checkbox
                  >
                  @if (!tc.checked) {
                    <mat-error align="start">
                      {{ 'ERROR.CHECKBOX' | translate }}</mat-error
                    >
                  }
                </div>
                <div
                  class="general-container"
                  fxLayout="row"
                  fxLayoutAlign="center center">
                  <button
                    class="btn-previous"
                    mat-raised-button
                    matStepperPrevious
                    type="button"
                    color="accent">
                    {{ 'GENERAL.PREVIOUS' | translate }}
                  </button>
                  <button
                    mat-raised-button
                    matStepperNext
                    type="button"
                    color="accent"
                    (click)="fetchFormData()"
                    [disabled]="!tc.checked">
                    {{ 'GENERAL.NEXT' | translate }}
                  </button>
                </div>
              </form>
            </mat-step>
            <mat-step [stepControl]="horizontalStepperStep5">
              <ng-template matStepLabel>{{
                'USERS.SINGLE.INFO.EMAIL' | translate
              }}</ng-template>
              <form fxLayout="column" [formGroup]="horizontalStepperStep5">
                <div fxFlex="1 0 auto" fxLayout="column">
                  <div fxFlex="2 0 auto" fxLayout="row">
                    <mat-form-field fxFlex="100" appearance="outline">
                      <mat-label>{{
                        'USERS.SINGLE.INFO.EMAIL' | translate
                      }}</mat-label>
                      <input
                        autoComplete="on"
                        matInput
                        formControlName="email"
                        required />
                      @if (
                        horizontalStepperStep5
                          .get('email')
                          .hasError('officialemail')
                      ) {
                        <mat-error>{{
                          'ERROR.EMAIL_SCHOOL' | translate
                        }}</mat-error>
                      }
                      @if (
                        horizontalStepperStep5.get('email').hasError('pattern')
                      ) {
                        <mat-error>{{
                          'ERROR.EMAIL_VALID' | translate
                        }}</mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>
                <div fxLayout="row" fxFill="100">
                  <div class="message-box primary">
                    {{ 'VALIDATION.STEPTWO.EMAIL.INFO' | translate }}
                  </div>
                </div>
                <div
                  class="general-container"
                  fxLayout="row"
                  fxLayoutAlign="center center">
                  <button
                    class="btn-previous"
                    mat-raised-button
                    matStepperPrevious
                    type="button"
                    color="accent">
                    {{ 'GENERAL.PREVIOUS' | translate }}
                  </button>
                  <button
                    mat-raised-button
                    matStepperNext
                    type="button"
                    color="accent">
                    {{ 'GENERAL.NEXT' | translate }}
                  </button>
                </div>
              </form>
            </mat-step>
            <mat-step [stepControl]="horizontalStepperStep4">
              <ng-template matStepLabel>{{
                'USERS.SINGLE.INFO.PASSWORD' | translate
              }}</ng-template>
              <form fxLayout="column" [formGroup]="horizontalStepperStep4">
                <div fxFlex="1 0 auto" fxLayout="column">
                  <div fxFlex="2 0 auto" fxLayout="column">
                    <mat-form-field
                      appearance="outline"
                      class="field-container">
                      <mat-label>{{
                        'USERS.SINGLE.INFO.PASSWORD' | translate
                      }}</mat-label>
                      <app-pass-visibility
                        #toggle
                        matSuffix></app-pass-visibility>
                      <input
                        autoComplete="on"
                        matInput
                        formControlName="password"
                        required
                        [type]="toggle.type"
                        placeholder="Password"
                        [formControl]="
                          horizontalStepperStep4.get('password') | formPipe
                        " />
                      @if (horizontalStepperStep4.get('password').invalid) {
                        <mat-error class="error-password">
                          {{ getErrorMessage() }}
                        </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <div fxFlex="2 0 auto" fxLayout="column">
                    <mat-form-field
                      appearance="outline"
                      class="field-container">
                      <mat-label>{{
                        'USERS.SINGLE.INFO.PWDCONFIRM' | translate
                      }}</mat-label>
                      <app-pass-visibility
                        #toggleConfirm
                        matSuffix></app-pass-visibility>
                      <input
                        autoComplete="on"
                        matInput
                        formControlName="passwordConfirmation"
                        required
                        [type]="toggleConfirm.type"
                        placeholder="Password"
                        [formControl]="
                          horizontalStepperStep4.get('passwordConfirmation')
                            | formPipe
                        " />
                    </mat-form-field>
                  </div>
                  <div class="error-container">
                    @if (horizontalStepperStep4.hasError('passwordNotMatch')) {
                      <mat-error class="message-box error">
                        {{ 'ERROR.IDENTICALPSWD' | translate }}
                      </mat-error>
                    }
                  </div>
                  @if (!displayPhone) {
                    <div fxLayout="row" fxFill="100">
                      <div class="message-box primary">
                        {{ 'VALIDATION.STEP4.PASSWORD.INFOTOKEN' | translate }}
                      </div>
                    </div>
                  }
                </div>
                <div
                  class="general-container"
                  fxLayout="row"
                  fxLayoutAlign="center center">
                  <button
                    class="btn-previous"
                    mat-raised-button
                    matStepperPrevious
                    type="button"
                    color="accent">
                    {{ 'GENERAL.PREVIOUS' | translate }}
                  </button>
                  <button
                    mat-raised-button
                    matStepperNext
                    type="button"
                    color="accent"
                    (click)="fetchFormData()">
                    {{ 'GENERAL.NEXT' | translate }}
                  </button>
                </div>
              </form>
            </mat-step>
            <mat-step>
              <ng-template matStepLabel>{{
                'VALIDATION.STEPFOUR.TITLE' | translate
              }}</ng-template>
              @if (!isUserUpdated) {
                <div
                  class="validation-step-four"
                  fxLayout="row"
                  fxLayoutAlign="center center">
                  {{ 'VALIDATION.STEPFOUR.TEXT' | translate }}
                </div>
              }
              <div fxFlex="2 0 auto" fxLayout="row"></div>
              @if (!isUserUpdated) {
                <div fxFlex="2 0 auto" fxLayout="column" class="user-info">
                  <div
                    fxFlex="2 0 auto"
                    fxLayout="row"
                    fxLayoutAlign="start center">
                    <div fxFlex="50" class="line-name">
                      {{ 'USERS.SINGLE.INFO.USUALLASTNAME' | translate }} :
                    </div>
                    <div fxFlex="50" fxLayoutAlign="start center">
                      {{ updatedUser?.lastName }}
                    </div>
                  </div>
                  <div
                    fxFlex="2 0 auto"
                    fxLayout="row"
                    fxLayoutAlign="start center">
                    <div fxFlex="50" class="line-name">
                      {{ 'USERS.SINGLE.INFO.USUALFIRSTNAME' | translate }} :
                    </div>
                    <div fxFlex="50" fxLayoutAlign="start center">
                      {{ updatedUser?.firstName }}
                    </div>
                  </div>
                  <div
                    fxFlex="2 0 auto"
                    fxLayout="row"
                    fxLayoutAlign="start center">
                    <div fxFlex="50" class="line-name">
                      {{ 'USERS.SINGLE.INFO.EMAIL' | translate }} :
                    </div>
                    <div fxFlex="50" fxLayoutAlign="start center">
                      {{ updatedUser?.email }}
                    </div>
                  </div>
                  @if (displayPhone) {
                    <div
                      fxFlex="2 0 auto"
                      fxLayout="row"
                      fxLayoutAlign="start center">
                      <div fxFlex="50" class="line-name">
                        {{ 'USERS.SINGLE.INFO.PHONE' | translate }} :
                      </div>
                      <div fxFlex="50" fxLayoutAlign="start center">
                        {{ updatedUser?.phone }}
                      </div>
                    </div>
                  }
                  <div
                    fxFlex="2 0 auto"
                    fxLayout="row"
                    fxLayoutAlign="start center">
                    <div fxFlex="50" class="line-name">
                      {{ 'USERS.SINGLE.INFO.PREFERREDLANGUAGE' | translate }} :
                    </div>
                    <div fxFlex="50" fxLayoutAlign="start center">
                      {{ userPreferedLanguage }}
                    </div>
                  </div>
                  <div
                    fxFlex="2 0 auto"
                    fxLayout="row"
                    fxLayoutAlign="start center">
                    <div fxFlex="50" class="line-name">
                      {{ 'USERS.SINGLE.INFO.PASSWORD' | translate }} :
                    </div>
                    <div fxFlex="50" fxLayoutAlign="start center">
                      ***********
                    </div>
                  </div>
                </div>
              }
              <div
                class="general-container"
                fxLayout="row"
                fxLayoutAlign="center center">
                @if (!isUserUpdated) {
                  <button
                    class="btn-previous"
                    mat-raised-button
                    matStepperPrevious
                    type="button"
                    color="accent"
                    [disabled]="isUserUpdated || isBusy">
                    {{ 'GENERAL.PREVIOUS' | translate }}
                  </button>
                }
                @if (!isUserUpdated) {
                  <button
                    mat-raised-button
                    type="button"
                    color="warn"
                    (click)="finishHorizontalStepper()"
                    [disabled]="isUserUpdated || isBusy">
                    {{ 'VALIDATION.STEP.FINISH' | translate }}
                  </button>
                }
              </div>
              @if (isBusy) {
                <div
                  class="general-container"
                  fxLayout="column"
                  fxLayoutAlign="center center">
                  <mat-progress-spinner
                    [color]="spinner.color"
                    [mode]="spinner.mode"
                    [value]="spinner.value"
                    [diameter]="spinner.diameter">
                  </mat-progress-spinner>
                  <div class="loading-container">
                    {{ 'GENERAL.LOADING' | translate }}
                  </div>
                </div>
              }
              @if (errorUpdate) {
                <div class="general-container" fxLayout="row" fxFill="100">
                  <div class="message-box error">
                    <app-error-message [error]="error.error" />
                  </div>
                </div>
              }
              <!-- Final Validation Screen -->
              @if (isUserUpdated) {
                <div
                  fxFlex="auto"
                  fxLayout="row"
                  fxLayoutAlign="center center"
                  class="finalformvalidation">
                  <div
                    fxFlex="60"
                    fxLayout="column"
                    fxFle
                    fxLayoutAlign="start">
                    <div
                      class="validationtxt"
                      fxLayout="row"
                      fxLayoutAlign="start">
                      {{ 'VALIDATION.CONFIRMVALIDATION' | translate }}
                    </div>
                    <div
                      class="confirm-container"
                      fxLayout="row"
                      fxFlex="100"
                      fxLayoutAlign="center center">
                      <div class="message-box success validationUsername">
                        {{ userAccountname }}
                      </div>
                    </div>
                    @if (updatedUser?.twoFactorAuthType === 'Token') {
                      <div
                        fxLayout="row"
                        fxFill="100"
                        class="general-container final-text">
                        <div class="message-box primary">
                          {{ 'VALIDATION.TOKENFINALINFO' | translate }}
                        </div>
                      </div>
                    }
                    @if (updatedUser?.twoFactorAuthType === 'SMS') {
                      <div
                        fxLayout="row"
                        fxFill="100"
                        class="general-container final-text">
                        <div class="message-box primary">
                          {{ 'VALIDATION.SMSFINALINFO' | translate }}
                        </div>
                      </div>
                    }
                    <div
                      class="confirm-container"
                      fxLayout="row"
                      fxLayoutAlign="center center">
                      <button
                        mat-raised-button
                        matStepperNext
                        type="button"
                        color="accent"
                        onclick="location.href='/login'">
                        {{ 'VALIDATION.ISMREDICRECTION' | translate }}
                      </button>
                    </div>
                  </div>
                  <div fxFlex="40" fxLayoutAlign="center center">
                    <img
                      src="assets/images/logos/logo.svg"
                      fxLayoutAlign="center center"
                      class="finalformvalidationimg"
                      alt="Logo ICT VS" />
                  </div>
                </div>
              }
            </mat-step>
          </mat-horizontal-stepper>
        </div>
      </div>
    </div>
  </div>
</div>
